



export const getApiBaseUrl = () => {
  // For local development, use the backend server port
  //comment out for replit because that is also a development environment.
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5001';
  }
  // For production (Replit/Azure), use relative URLs since frontend and backend share the same domain


  if (process.env.NODE_ENV === 'production') {
    return 'https://analytics.kinore.com';
  }


  return '';
};

export const getAppBaseUrl = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:3000';
  }
  return window.location.origin;
};